export * from './src/password-forgotten-view.component';
